import React, {PropTypes} from 'react';
import classNames from 'classnames';
import FieldValidationError from './FieldValidationError.jsx';
import DatePicker from './util/DatePicker/DatePicker.jsx';
import {
  OverlayTrigger,
  Popover
} from 'react-bootstrap';

const StandardField = ({
  autoFocus,
  disabled,
  input,
  label,
  type,
  placeholder,
  step,
  min,
  max,
  minDate,
  maxDate,
  name,
  style,
  required,
  todayHighlight,
  tooltip,
  tooltipPosition,
  meta: {
    touched,
    error
  },
  onCustomChange
}) => (
  <div className={classNames(
    {'form-group': placeholder || label},
    {'has-error': touched && error}
  )}>
    {
      label || placeholder
      ? tooltip
        ? <OverlayTrigger
            trigger={["click", "hover"]}
            rootClose={true}
            placement={tooltipPosition}
            overlay={<Popover id={`popover-positioned-${tooltipPosition}`}>{tooltip}</Popover>}>
            <label htmlFor={name}>
              {label || placeholder} <i className="fa fa-question-circle-o" />
            </label>
          </OverlayTrigger>
        : <label htmlFor={name}>{label || placeholder}</label>
      : null
    }
    {type === 'date'
      ? <DatePicker
          {...input}
          minDate={minDate}
          maxDate={maxDate}
          autoFocus={autoFocus}
          disabled={disabled}
          placeholder={placeholder}
          style={style}
          required={required}
          todayHighlight={todayHighlight}
          name={name}
          onChange={event => {
            // redux-form overrides change event if provided to Field
            // use custom handler for other specific handling
            onCustomChange(event);
            if (input && (typeof input.onChange === "function")) {
              input.onChange(event);
            }
          }}
        />
      : <input
          {...input}
          autoFocus={autoFocus}
          className="form-control"
          disabled={disabled}
          min={min}
          max={max}
          placeholder={placeholder}
          step={step}
          style={style}
          type={type}
          required={required}
          onChange={event => {
            // redux-form overrides change event if provided to Field
            // use custom handler for other specific handling
            onCustomChange(event);
            if(input)
              input.onChange(event);
          }}
        />
    }
    <FieldValidationError
      touched={touched}
      error={error}
    />
  </div>
);

StandardField.propTypes = {
  autoFocus: PropTypes.bool,
  input: PropTypes.object,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  meta: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  step: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  style: PropTypes.object,
  required: PropTypes.bool,
  todayHighlight: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.string,
  onCustomChange: PropTypes.func
};

StandardField.defaultProps = {
  type: 'text',
  onCustomChange: () => {},
  tooltipPosition: 'top'
};

export default StandardField;



// WEBPACK FOOTER //
// ./src/features/shared/StandardField.jsx